export default "__VITE_ASSET__2e676344__"